import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useProjectDetailPage } from "../store";
import TimelineIcon from '@mui/icons-material/Timeline';

const nextStepsPlanning = [
    "Los administradores actualmente están implementando la planeación, estaremos informandote el avance en los próximos días habiles.",
    "Has pagado el 'anticipo del proyecto' lo cual incluye la documentación propuesta (Diagramas), la plenación de aplicaciónes y tareas, y el esqueleto de tu aplicación (usuarios, inicio de sesión, colores, etc)"
];
const nextStepsPayment = [
    "AguayoDevs solo trabaja bajo pagos adelantados y entregas parciales y totales.",
    "Tienes pagos atrazados, pagalos para continuar con el desarrollo de tu aplicación y asignarte una fecha de entrega parcial."
];
const nextStepsInDevelop = [
    "Actualmente estamos trabajando en el desarrollo de tu proyecto, consulta el apartado 'Aplicaciones' para ver los avances de tu proyecto"
];
const nextStepsCompleted = [
    "El proyecto ha sido concluido e implementado con éxito, revisa el apartado apps para navegar hacia tu proyecto"
];
const nextStepsCanceled = [
    "El proyecto ha sido cancelado por un administrador, lamentamos no poder atender tu proyecto en este momento."
];
const nextStepsPaused = [
    "El proyecto ha sido pausado por causa mayor por un administrador por favor sea paciente."
];

const STATUS_COLOR = (theme, name) => {
  switch (name) {
    case 'planning': return theme.palette.info.main;
    case 'in-develop': return theme.palette.info.main;
    case 'payment-required': return theme.palette.error.main;
    case 'cancelled': return theme.palette.error.main;
    case 'paused': return theme.palette.warning.main;
    case 'completed': return theme.palette.success.main;
    default: return theme.palette.grey[500];
  }
};

const StatusCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  borderRadius: 8,
  overflow: "hidden",
}));

const StatusChip = styled(Chip, { shouldForwardProp: (p) => p !== 'statusName' })(
  ({ theme, statusName }) => ({
    backgroundColor: STATUS_COLOR(theme, statusName),
    color: theme.palette.common.white,
    fontWeight: 700,
  })
);

const Dot = styled('span')(({ theme }) => ({
  width: 10,
  height: 10,
  borderRadius: '50%',
  background: theme.palette.primary.main,
  display: 'inline-block',
}));

const getArrayNextStepsByStatus = (status) => {
    if (status === 'planning') return nextStepsPlanning;
    if (status === 'in-develop') return nextStepsInDevelop;
    if (status === 'payment-required') return nextStepsPayment;
    if (status === 'cancelled') return nextStepsCanceled;
    if (status === 'paused') return nextStepsPaused;
    if (status === 'completed') return nextStepsCompleted;
    return ['Contactar a soporte'];
};

export const CardNextSteps = () => {
  const { project } = useProjectDetailPage();
  const { status } = project || {};
  if (!status) return null;

  const steps = getArrayNextStepsByStatus(status);

  return (
    <StatusCard elevation={1}>
      <Box
        sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            py: 1.5, px: 2,
            display: "flex", alignItems: "center", justifyContent: "space-between",
        }}
        >
        <Typography variant="h6" color="inherit" sx={{ fontWeight: 700, display: "flex", alignItems: "center", gap: 1 }}>
            <TimelineIcon fontSize="small" />
            Estado del Proyecto
        </Typography>
        <StatusChip label={status} statusName={status} size="small" />
    </Box>
      <CardContent>
        <Box sx={{ display: 'grid', rowGap: 2, gridTemplateColumns: '24px 1fr' }}>
          {steps.map((it, idx) => (
            <Box key={`${it}-${idx}`} sx={{ display: 'contents' }}>
              <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                <Dot />
                {idx < steps.length - 1 && (
                  <Box sx={{ position: 'absolute', top: 12, bottom: -12, width: 2, bgcolor: 'divider' }} />
                )}
              </Box>
              <Box sx={{ p: 1.25, borderRadius: 1.5, bgcolor: (t) => t.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.03)', border: (t) => `1px solid ${t.palette.divider}` }}>
                <Typography variant="body2">
                  {it}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
    </StatusCard>
  );
};